/* DN (Sentry DE-1VF, Vorbild US-1Y): jQuery-Ajax als Promise mit Fangnetz. Ein 422 von /cart/update.js
   ("Parameter updates ist ungueltig", ausgeloest durch leere Keys im color-array) lief vorher als
   unbehandelte Promise-Ablehnung durch. Der error-Callback im Aufruf bleibt, die Ablehnung wird hier zu null. */
window.dnAjaxSicher = window.dnAjaxSicher || function (dnOptionen) {
  return $.ajax(dnOptionen).catch(function () { return null; });
};
window.dnGetJsonSicher = window.dnGetJsonSicher || function (dnUrl, dnErfolg) {
  return $.getJSON(dnUrl, dnErfolg).catch(function () { return null; });
};
/* DN (Sentry US-1Y): jQuery-Ajax als Promise mit Fangnetz - ein 422 von /cart/update.js
   ("updates parameter is invalid") loeste vorher eine unbehandelte Promise-Ablehnung aus.
   Der error-Callback im Aufruf bleibt, die Ablehnung wird hier in null umgewandelt. */
window.dnAjaxSicher = window.dnAjaxSicher || function (dnOptionen) {
  return $.ajax(dnOptionen).catch(function () { return null; });
};
/*
  ---------- Kaufknopf der Einzelproduktseite ----------

  Auf dem Template `single-us-design` steht die Designwahl neben dem
  Produkt und nicht davor: das Produkt ist schon gewaehlt, der Kaufknopf
  gehoert dem Theme. Diese Datei faengt aber jeden Klick auf
  `.inventory-product` ab und baut daraus ein Set — gemessen landete das
  Produkt mit `_bundle-parent`, `_starter-set-parent` und einem leeren
  `_childItemsJson` im Warenkorb statt als gewoehnliche Zeile.

  Die Klasse kommt dabei nicht aus dem Template. assets/devify_js.js.liquid
  (~1053) setzt sie auf JEDER Produktseite:

    if ($('.subscription_widget_02 input[data-variant-id]').first()) { ... }

  Ein leeres jQuery-Objekt ist wahr, die Bedingung trifft also immer. Wo
  diese Datei nicht geladen wird, faellt das nicht auf.

  Deshalb ein Schalter an der Body-Klasse. Alle anderen Templates lesen
  `false` und aendern sich nicht.
*/
if (typeof window.dnKaufknopfFrei !== 'function') {
  window.dnKaufknopfFrei = function () {
    /* Beide Templates mit dem neuen Design tragen dn-neues-pdp. */
    return !!(document.body && document.body.classList.contains('dn-neues-pdp'));
  };
}

function formatExpandedItemsToJsonArray(items) {
  const jsonArray = items.map(item => ({
    id: `gid://shopify/ProductVariant/${item.id}`,
    quantity: 1,
    customKey: item.price,
    isOptional: item.optional
  }));
  return JSON.stringify(jsonArray);
}


function generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

async function addRelated(variantIdArray, $that, optionalIndex) {
    let optionalIndexInt = optionalIndex.map(function(str) { return parseInt(str) });
    let set_id = generateUID();

    let reduced_obj = variantIdArray.reduce(function(obj, b) {
        obj[b] = ++obj[b] || 1;
        return obj;
    }, {});

    let indexedObj = {};

    for (let i = 0; i < variantIdArray.length; i++) {
        indexedObj[i] = variantIdArray[i];
    }

    var product_data = [];
 
    // let child_variant_ids = "";
    // let free_variant_ids = "";
  
    // Object.keys(reduced_obj).forEach((key, index) => {
    //     if (index != 0) {
    //         if (!child_variant_ids.includes(key)) {
    //             child_variant_ids += key + ":" + reduced_obj[key];
    //             child_variant_ids += '__';
    //         }
    //     }
    // });



    //  let expandedItems =   [];
    // $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
    //     const priceVar = parseInt($(this).attr('data-original-price'), 10) / 100;
    //     const variantId = parseInt($(this).attr('variant-id'), 10);
    //     let isOptional = false;
    //     if ($(this).hasClass('optional-switcher')) {
    //         isOptional = true;
    //     }

    //     expandedItems.push({ id: variantId, price: priceVar, optional: isOptional });
        
    //     if (free_variant_ids === "") {
    //         free_variant_ids = `${variantId}`;
    //     } else {
    //         free_variant_ids += `,${variantId}`;
    //     }
    // });

//     const expandJSON = formatExpandedItemsToJsonArray(expandedItems);
//     console.log(expandJSON);
  
//     $('.remover_upsell:checked').each(function() {
//         child_variant_ids += parseInt($(this).val()) + ":" + 1;
//         child_variant_ids += '__';
//     });

//     $('.optional_accessories_block_product_item.coladded').each(function() {
//         child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
//         child_variant_ids += '__';
//     });

//     $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
//       if ($(this).is(':visible')) {
//         child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
//         child_variant_ids += '__';
//       }
//     });

//   $('.free_product_hidden').each(function() {
//         child_variant_ids += parseInt($(this).val()) + ":" + 1;
//         child_variant_ids += '__';
//   });


    let parentProductID;
    let parentProductHandle = $('variant-picker.product-form__variants').attr('handle');
    for (let key in indexedObj) {
        if (indexedObj.hasOwnProperty(key)) {
            if (key == 0) {
                parentProductID = parseInt(indexedObj[key]);
            }
        }
    }


    

    /*
      ---------- Set discount (ported from snippets/dn-design-chooser.liquid, nachlass()) ----------

      The set price covers the required designs and the free gifts
      together. The gap between their list prices and the set price is
      the discount the set promises. It goes to the gifts first (usually
      it covers them: they are free and carry _bundled-free); whatever is
      left is spread cent-exact over the required designs. If it does not
      even cover the gifts (the 2-design set), they get it proportionally
      and the designs stay at list price.

      _discountAmount is in dollars per line, as the theme expects
      (assets/dn-cart.js, sections/mini-cart.liquid).

      Set price in cents from the theme's price row; on the new PDP it
      sits hidden in snippets/dn-preisquelle.liquid.
    */
    function toDollars(cents) { return Math.round(cents) / 100; }

    function getSetPriceCents() {
        let priceEl = document.querySelector('[data-product-price-list] .price[data-price], [data-dn-preisquelle] [data-price]');
        let value = priceEl ? parseInt(priceEl.getAttribute('data-price'), 10) : NaN;
        return isNaN(value) ? 0 : value;
    }

    let requiredSwitchers = $('.color-selection__grid-item.required-switcher color-switcher.color-selection__image.required-switcher.coladded');
    let optionalSwitchers = $('.color-selection__grid-item.optional-switcher color-switcher.color-selection__image.optional-switcher.coladded');

    /*
      Design lines carry the same tags as dn-design-chooser so the cart
      card (snippets/dn-cart-set.liquid) tells designs from extras and can
      prefill the edit link: _onetime_tag marks a design, _set_optional an
      optional one. Consumers only check the key; the count in the value
      is the set size (required slots from #pick-color-id).
    */
    let setDesignCount = parseInt($('#pick-color-id').attr('data-free-colors'), 10) || requiredSwitchers.length;
    let onetimeTag = 'starter_set_onetime_' + setDesignCount + '_designs';

    /* How often the same variant appears within a group (for _baseQty). */
    function countSameVariant($group, variantId) {
        let count = 0;
        $group.each(function() { if (parseInt($(this).attr('variant-id')) === variantId) count++; });
        return count;
    }

    /*
      Gifts from block-variant-picker-v3 (free_gifts_in_set). Price in
      cents from data-price; older snippets only carry data-discount,
      which there equals price + 1 cent (Liquid: price - (0 - 1)).
    */
    let gifts = [];
    /*
      Starter-Set B/C (snippets/dn-starter-b.liquid, 2026-09-23): Nail Glue ab 4 und Beauty Bag ab 6 Designs sind
      freigeschaltete Geschenke (data-dn-sb-gift). Sie kommen voll gratis in den Warenkorb (_bundled-free) und laufen
      nicht durch die Verteilung des Set-Preises - sonst standen sie im Checkout mit einem Restpreis (Nail Glue $2.33).
      Die Summe bleibt gleich, der Set-Preis verteilt sich wie ohne sie.
    */
    let unlockGifts = [];
    $('.free_product_hidden').each(function() {
        let id = parseInt($(this).val());
        if (!id) return;
        let priceCents = parseInt($(this).attr('data-price'), 10);
        if (isNaN(priceCents)) priceCents = (parseInt($(this).attr('data-discount'), 10) || 1) - 1;
        if (this.hasAttribute('data-dn-sb-gift')) { unlockGifts.push({ id: id, priceCents: Math.max(0, priceCents) }); return; }
        gifts.push({ id: id, priceCents: Math.max(0, priceCents) });
    });

    let designsTotal = 0;
    requiredSwitchers.each(function() { designsTotal += parseInt($(this).attr('data-original-price'), 10) || 0; });
    let giftsTotal = gifts.reduce(function(sum, gift) { return sum + gift.priceCents; }, 0);

    let discountBudget = Math.max(0, designsTotal + giftsTotal - getSetPriceCents());
    let giftsDiscount = Math.min(giftsTotal, discountBudget);
    let designsDiscount = discountBudget - giftsDiscount;

    /* Required designs: split evenly, the remainder of the division goes cent by cent to the first lines. */
    let perDesign = requiredSwitchers.length ? Math.floor(designsDiscount / requiredSwitchers.length) : 0;
    let remainder = requiredSwitchers.length ? designsDiscount - perDesign * requiredSwitchers.length : 0;

    requiredSwitchers.each(function(index) {
        let variantId = parseInt($(this).attr('variant-id'));
        let priceCents = parseInt($(this).attr('data-original-price'), 10) || 0;
        let discountCents = perDesign + (index < remainder ? 1 : 0);

        let prod = { quantity: 1, id: variantId };
        prod["properties"] = {
            '_bundled-product': true,
            '_bundled-product-discount': true,
            '_set_id': set_id,
            '_baseQty': countSameVariant(requiredSwitchers, variantId),
            '_onetime_tag': onetimeTag,
            "_set_handle": parentProductHandle,
            "_set_variant": parentProductID
        };
        if (discountCents > 0) {
            prod["properties"]['_discountAmount'] = toDollars(discountCents);
            prod["properties"]['Original Price'] = toDollars(priceCents);
        } else {
            prod["properties"]['_discountAmount'] = 0;
        }
        product_data.push(prod);
    });

    /* Optional designs are not part of the set price: they get their own discount (data-percent, like the theme). */
    optionalSwitchers.each(function(index) {
        let variantId = parseInt($(this).attr('variant-id'));
        let offPercent = parseFloat($(this).attr('data-percent')) || 0;
        let priceCents = parseInt($(this).attr('data-original-price'), 10) || 0;
        let discountCents = Math.round(priceCents * offPercent / 100);

        let prod = { quantity: 1, id: variantId };
        prod["properties"] = {
            '_bundled-product': true,
            '_bundled-product-discount': true,
            '_set_id': set_id,
            '_baseQty': countSameVariant(optionalSwitchers, variantId),
            '_onetime_tag': onetimeTag,
            '_set_optional': true,
            "_set_handle": parentProductHandle,
            "_set_variant": parentProductID
        };
        if (discountCents > 0) {
            prod["properties"]['_discountAmount'] = toDollars(discountCents);
            prod["properties"]['Original Price'] = toDollars(priceCents);
        } else {
            prod["properties"]['_discountAmount'] = 0;
        }
        product_data.push(prod);
    });

    /*
      Gifts: discount split proportionally, the rounding remainder goes
      to the last one. If it covers the full price the line is free and
      carries _bundled-free as before; otherwise it is a regular line
      discount.
    */
    let allocated = 0;
    gifts.forEach(function(gift, i) {
        let discountCents;
        if (giftsTotal <= 0) discountCents = 0;
        else if (i === gifts.length - 1) discountCents = giftsDiscount - allocated;
        else discountCents = Math.round(gift.priceCents * giftsDiscount / giftsTotal);
        discountCents = Math.max(0, Math.min(gift.priceCents, discountCents));
        allocated += discountCents;

        let giftProd = { quantity: 1, id: gift.id };
        giftProd["properties"] = {
            '_bundled-product': true,
            '_set_id': set_id,
            '_set_handle': parentProductHandle,
            '_set_variant': parentProductID
        };
        if (gift.priceCents > 0 && discountCents >= gift.priceCents) {
            giftProd["properties"]['_bundled-free'] = true;
            giftProd["properties"]['_discountAmount'] = toDollars(gift.priceCents);
        } else if (discountCents > 0) {
            giftProd["properties"]['_discountAmount'] = toDollars(discountCents);
            giftProd["properties"]['Original Price'] = toDollars(gift.priceCents);
        } else {
            giftProd["properties"]['_discountAmount'] = 0;
        }
        product_data.push(giftProd);
    });
    unlockGifts.forEach(function(gift) {
        let giftProd = { quantity: 1, id: gift.id };
        giftProd["properties"] = {
            '_bundled-product': true,
            '_set_id': set_id,
            '_set_handle': parentProductHandle,
            '_set_variant': parentProductID
        };
        if (gift.priceCents > 0) {
            giftProd["properties"]['_bundled-free'] = true;
            giftProd["properties"]['_discountAmount'] = toDollars(gift.priceCents);
        } else {
            giftProd["properties"]['_discountAmount'] = 0;
        }
        product_data.push(giftProd);
    });

    /*
      Fold identical lines (like dn-design-chooser, 2026-09-08): the same
      design picked twice is merged by Shopify into ONE line with
      quantity 2 - and _discountAmount applies per line, not per unit.
      So add up the quantity and sum the discount, otherwise it only
      counts once.
    */
    let folded = [];
    product_data.forEach(function(line) {
        let props = line.properties || {};
        let coreProps = {};
        Object.keys(props).sort().forEach(function(k) { if (k !== '_discountAmount') coreProps[k] = props[k]; });
        let foldKey = line.id + '|' + JSON.stringify(coreProps);
        let existing = folded.find(function(entry) { return entry.foldKey === foldKey; });
        if (!existing) { folded.push({ foldKey: foldKey, line: line }); return; }
        existing.line.quantity += line.quantity;
        if (props['_discountAmount'] != null) {
            let total = (parseFloat(existing.line.properties['_discountAmount']) || 0) + parseFloat(props['_discountAmount']);
            existing.line.properties['_discountAmount'] = Math.round(total * 100) / 100;
        }
    });
    product_data = folded.map(function(entry) { return entry.line; });

    // for (let key in indexedObj) {
    //     if (indexedObj.hasOwnProperty(key)) {
    //         if (key == 0) {
    //             let hiddenColorArray = $('.hidden-color[value!=""]');
    //             if (hiddenColorArray.length > 0) {
    //                 let props = {};
    //                 $('.hidden-color[value!=""]').each(function(index) {
                  
    //                     var color_string = "_Farbe_Img " + (index + 1);
    //                     props[color_string] = $(this).attr('variant-img');
    //                 });
    //                 props['_bundle-parent'] = true;
    //                 props['_set'] = set_id;
    //               if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
    //                 props['_variants_set'] = child_variant_ids;
    //                 props['_childItemsJson'] = expandJSON;
    //                 props['_free_variants'] = free_variant_ids;
    //                 let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
    //                 product_data.push(prod);
    //             }
    //             let hiddenColorArray2 = $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded');
    //             if (hiddenColorArray2.length > 0) {
    //                 let props2 = {};
    //                 $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.coladded').each(function(index) {
    
    //                     var color_string = "_Farbe_Img " + (index + 1);
    //                     props2[color_string] = $(this).attr('variant-img');
    //                     var color_name= "_Farbe_Name " + (index + 1);
    //                     props2[color_name] = $(this).attr('variant-name');
    //                 });
    //                 props2['_bundle-parent'] = true;
    //                 props2['_set'] = set_id;
    //               if(window.atcPriceCompare != undefined) props2['_compareOriginalPrice'] = window.atcPriceCompare;
    //                 props2['_variants_set'] = child_variant_ids;
    //                 props2['_childItemsJson'] = expandJSON;
    //                 props2['_free_variants'] = free_variant_ids;
    //                 let prod2 = { quantity: 1, id: parseInt(indexedObj[key]), properties: props2 };
    //                 product_data.push(prod2);
    //             }
    //         } else {
    //             let optionalFound = false;
    //             let originalPriceOptional;
    //             let prod = { quantity: 1, id: parseInt(indexedObj[key]) };
    //             $('.color-selection__grid-item.optional-switcher color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
    //                 let varId = parseInt($(this).attr('variant-id'));
    //                 if (parseInt(indexedObj[key]) == varId && optionalIndexInt.includes(parseInt(key))) {
    //                     let optionalQty = 0;
    //                     $('.color-selection__grid-item.optional-switcher color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
    //                         let varIdInner = parseInt($(this).attr('variant-id'));
    //                         if (varId === varIdInner) {
    //                             optionalQty = optionalQty + 1;
    //                             originalPriceOptional = parseFloat($(this).attr('data-original-price') / 100);
    //                         }
    //                     });
                      
    //                   let offAmount = parseFloat($(this).attr('data-percent'));
    //                   if (originalPriceOptional) {
    //                     let optionalPercentOff = parseInt($('#pick-color-id').attr('data-optional-off'));
    //                     offAmount = originalPriceOptional * (optionalPercentOff / 100);
    //                   }
    //                     prod["properties"] = {
    //                         '_bundled-product': true,
    //                         '_bundled-product-discount': true,
    //                         '_discountAmount': offAmount,
    //                         '_set_id': set_id,
    //                         '_baseQty': optionalQty
    //                     };
    //                     optionalFound = true;
    //                     return false;
    //                 }
    //             });
    //             if (!optionalFound) {
    //                 let freeQty = 0;
    //                 $('.color-selection__grid-item.required-switcher color-switcher.color-selection__image.required-switcher.coladded').each(function(index) {
    //                     let varIdInner = parseInt($(this).attr('variant-id'));
    //                     if (parseInt(indexedObj[key]) === varIdInner) {
    //                         freeQty = freeQty + 1;
    //                     }
    //                 });
    //                 prod["properties"] = {
    //                     '_bundled-product': true,
    //                     '_bundled-free': true,
    //                     '_set_id': set_id,
    //                     '_baseQty': freeQty
    //                 }
    //             }
              
    //             product_data.push(prod);
    //         }
    //     }
    // }

    // $('.remover_upsell:checked').each(function() {
    //     let upsell_prod = { quantity: 1, id: parseInt($(this).val()) };
    //     upsell_prod["properties"] = {
    //         '_bundled-product': true,
    //         '_discountAmount': parseFloat($(this).attr('discount')),
    //         '_set_id': set_id
    //     };
    //     product_data.push(upsell_prod);
    // });

    // $('.optional_accessories_block_product_item.coladded').each(function() {
    //     let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
    //     upsell_prod_opt["properties"] = {
    //         '_bundled-product': true,
    //         '_discountAmount': parseFloat($(this).attr('data-discount')),
    //         '_set_id': set_id
    //     };
    //     product_data.push(upsell_prod_opt);
    // });

    // $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
    //   if ($(this).is(':visible')) {
    //     let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
    //     upsell_prod_opt["properties"] = {
    //         '_bundled-product': true,
    //         '_bundled-free': true,
    //         '_discountAmount': parseFloat($(this).attr('data-discount')),
    //         '_set_id': set_id
    //     };
    //     product_data.push(upsell_prod_opt);
    //   }
    // });

    // $('.free_product_hidden').each(function() {
    //     let upsell_prod_opt = { quantity: 1, id: parseInt($(this).val()) };
    //     upsell_prod_opt["properties"] = {
    //         '_bundled-product': true,
    //         '_bundled-free': true,
    //         '_discountAmount': parseFloat($(this).attr('data-discount')),
    //         '_set_id': set_id,
    //         '_set_handle': parentProductHandle,
    //         '_set_variant': parentProductID
    //     };
    //     product_data.push(upsell_prod_opt);
    // });

    console.log(product_data);

    async function addItemsToCartAndProceed() {
        try {
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js?_=${Date.now()}`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            if (sessionStorage.getItem("utm_ablyft")) {
                const utm_ablyft = JSON.parse(sessionStorage.getItem("utm_ablyft"));
                   const cartAttributes = {
                        ablyft_source: 'ab_test',
                        ablyft_experiment_id: utm_ablyft.experiment_id,
                        ablyft_variation_id: utm_ablyft.variation_id,
                        ablyft_campaign: utm_ablyft.product_handle
                    };

                const attrResponse = await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
                    body: JSON.stringify({
                        attributes: cartAttributes
                    }),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                    },
                    method: 'POST'
                });

                const attrResponseJson = await attrResponse.json();

                if (!attrResponse.ok) {
                    throw attrResponseJson;
                }
            }
            
                setTimeout(function() {
                    $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
                }, 200);

                fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    /* Sentry US-3F (2026-09-15): Section-Antwort ohne #mini-cart (Bot-/Fehlerseite) -> nichts tun statt TypeError */
                    const quelleBox = html.querySelector("#mini-cart"), zielBox = document.querySelector('#mini-cart');
                    if (quelleBox && zielBox) zielBox.innerHTML = quelleBox.innerHTML;
                })

                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();

                    if(!window.upsellPopupActive){
                        // if ($('body').hasClass('template_suffix_set_starter_new_pr_on')) {
                        //     window.location.href = '/checkout';
                        //     if (sessionStorage.getItem("subscriptionUpsell") !== null) {
                        //         window.upsellPopupFuncAR(cartContent, $that);
                        //     }
                        // } else {
                            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent
                                }
                            }));

                            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent,
                                    openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                                }
                            }));
                        // }
                    } else {

                        // if (sessionStorage.getItem("subscriptionUpsell") !== null) {
                        //     window.upsellPopupFuncAR(cartContent, $that);
                        // } else {
                            window.upsellPopupFunc(cartContent, $that);
                        // }
                    }

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              
                $('.loader-button__text').show();
                $('.loader-button__loader').hide();
                $('.inventory-product[aria-busy]').removeAttr('aria-busy');
            

            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
        } catch (error) {
            /* 2026-09-14: Knopf zurueckgeben - nach einem Fehler blieb er sonst im Ladezustand haengen */
            $('.loader-button__text').show();
            $('.loader-button__loader').hide();
            $('.inventory-product[aria-busy]').removeAttr('aria-busy');
            $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
        }
    }

    // Call the function to add items to the cart and proceed
    addItemsToCartAndProceed();
}

$(document).ready(function() {
  
$('body').on('click', '.inventory-product', async function (e) {
    /* Einzelproduktseite: der gewoehnliche Kaufpfad des Themes bleibt. */
    if (window.dnKaufknopfFrei && window.dnKaufknopfFrei()) return;

    e.preventDefault();
    e.stopPropagation();
    $(this).find('.loader-button__text').hide();
    $(this).find('.loader-button__loader').show();
    /* 2026-09-14: aria-busy dazu - die Sticky-Leiste spiegelt es und dreht mit */
    $(this).attr('aria-busy', 'true');

    $('#MainPaymentContainer').attr('disabled', 'disabled').addClass('disabled');

    const $that = this;

    if ($(this).hasClass('updateProduct')) {
        const pre_set_id = $(this).attr('set-id'); // Get the pre_set_id
        let keysToRemove = []; // Array to store keys of items to be removed

        // Get the cart data
        await window.dnGetJsonSicher(`${window.themeVariables.routes.cartUrl}.js`, function (cart) {
            const items = cart.items;

            // Iterate through each cart item
            items.forEach((item) => {
                // Check for the _set_id or _set property
                if ((item.properties && item.properties._set_id === pre_set_id) ||
                    (item.properties && item.properties._set === pre_set_id)) {
                    keysToRemove.push(item.key); // Store the item's key
                }
            });
        });

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    } else if ($(this).hasClass('updateSingleProducts')) {
  
        const pre_set_id = $(this).attr('color-array');
        let keysToRemove = (pre_set_id?.split(',') || []).map((dnKey) => dnKey.trim()).filter(Boolean); /* DN: leere Keys ergeben ein 422 */
      
        $(this).attr('color-array', '');
        $(this).removeClass('updateSingleProducts')

        // If we have keys to remove, make a single API call to remove them
        if (keysToRemove.length > 0) {
            const updates = {}; // Object to hold update data for cart API
            keysToRemove.forEach((key) => {
                updates[key] = 0; // Setting quantity to 0 removes the item
            });

            await window.dnAjaxSicher({
                url: `${window.themeVariables.routes.cartUpdateUrl}.js`,
                method: 'POST',
                dataType: 'json',
                data: { updates: updates },
                success: function (data) {
                console.log(data);
                },
                error: function (error) {
                    console.error('Error removing items from cart:', error);
                }
            });
        }
    }

    // Collect other items
    let items = [];
    let itemsOptionalIndex = [];

        items.push(parseInt($('.product-form__buy-buttons input[name="id"]').val()));


        $('.color-selection__grid-item:not(.disabled-color) color-switcher.color-selection__image.optional-switcher.coladded').each(function(index) {
            items.push(parseInt($(this).attr('variant-id')));
            itemsOptionalIndex.push(items.length - 1);
        });

  /* free nail oil patch */
 
     if ($('body').hasClass('addFreeNailOil')) {
            items.push(39520435142843);
        }
        if ($('body').hasClass('addFreePrimer')) {
            items.push(42724339351739);
        }
        if ($('body').hasClass('addFreeEntfernerBasics')) {
            items.push(46799604515154);
        }

  addRelated(items, $that, itemsOptionalIndex);
  
  console.log(items);
  
});
  
});